import React from "react";

function Trending() {
  return (
    <div>
      <h1>Trending Component</h1>
    </div>
  );
}

export default Trending;
